import {LoaderFunctionArgs} from 'react-router-dom';
import {getRootStore} from '../../app.bootstrap';
import {getAppTracer} from '../../../app.tracer';
import {IConnectivityStandaloneStore, ConnectivityStandaloneStore} from './connectivity-standalone.stores';

const trace = getAppTracer('connectivity-standalone.loader');

export async function connectivityStandaloneRouteLoader(
    args: LoaderFunctionArgs
): Promise<IConnectivityStandaloneStore> {
    trace.info('Starting');
    const rootStore = getRootStore();

    const localizationService = rootStore.localizationService;
    if (!localizationService.isInitialized()) {
        await localizationService.init();
    }

    const store = new ConnectivityStandaloneStore();

    trace.info('Completed successfully');
    return store;
}
